import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StyledButtonDisabled } from '../custom-styled-components/_MyCustomSC';
import { Input, Button, Checkbox, InputNumber } from 'antd';

const StyledParentDiv = styled.div`
  width: 800px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const StyledButton = styled(Button)`
  &&.ant-btn {
    color: ${(props) => props.color} !important;
  }
`;

/**
 * @component
 * @category Form Page
 * @subcategory FCL Tab
 * @name RowMainContent
 * @description It's the FCL shipping single load component
 * <br> <br>
 * **Example**
 * ```js
 *   <RowMainContent rowId={3}/>
 * ```
 */
class RowMainContent extends Component {
  state = {};

  componentDidMount = () => {
    //check if a row already exist in redux state, if not then create it with default redux state
    if (!this.props.fclShipping[this.props.rowId]) {
      this.props.updateFclShipping(this.props.rowId, {
        input: 1,
        type: "40'",
        isOverweight: false,
      });
    }
    this.props.updateLoadSummaryText();
  };

  componentWillUnmount = () => {
    // it's removed newly
    // this.props.deleteFclShipping(this.props.rowId);
    this.props.updateLoadSummaryText();
  };

  /**
   * @description when FCL single load overweight checkbox is toggled, this method is invoked
   * <br> <br>
   * **onCheckboxChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | checkbox onchange mouse event |

   * Returns: Type: void
   */
  onCheckboxChange = (e) => {
    this.props.updateFclShipping(this.props.rowId, {
      isOverweight: e.target.checked,
    });
  };

  /**
   * @description when FCL single load no. of unit input field is changed, this method is invoked
   * <br> <br>
   * **onInputNumChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | number        | input value, it only accepts numeric key press |

   * Returns: Type: void
   */
  onInputNumChange = (value) => {
    this.props.updateFclShipping(this.props.rowId, { input: value });
    this.props.updateLoadSummaryText();
  };

  /**
   * @description when FCL single load type of container is selected, this method is invoked
   * <br> <br>
   * **onBtnsClick(type) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | type          | string        | container type e.g. `20'` `40'` `40'HC` `45'HC` |

   * Returns: Type: void
   */
  onBtnsClick = (type) => {
    this.props.updateFclShipping(this.props.rowId, { type });
  };

  render() {
    const { fclShipping, rowId, removeFcl45HcContainer } = this.props;
    const { type, input, isOverweight } = fclShipping[rowId] || {};

    // console.log('rowId: ', rowId, ', fcl shipping: ', fclShipping);

    return (
      <>
        <StyledParentDiv className="testBla1">
          <InputNumber
            min={1}
            value={input}
            onChange={this.onInputNumChange}
            style={{ maxWidth: '90px' }}
          />
          <StyledButtonDisabled type="disabled">Standard</StyledButtonDisabled>

          <StyledButton
            type="default"
            style={{
              width: '100px',
              fontSize: '13px',
              borderColor: `${type}` === "20'" ? '#0093ee' : '',
            }}
            onClick={() => this.onBtnsClick("20'")}
            color={`${type}` === "20'" ? '#0093ee' : '#627b93'}
          >
            20'
          </StyledButton>
          <StyledButton
            type="default"
            style={{
              width: '100px',
              fontSize: '13px',
              borderColor: `${type}` === "40'" ? '#0093ee' : '',
            }}
            onClick={() => this.onBtnsClick("40'")}
            color={`${type}` === "40'" ? '#0093ee' : '#627b93'}
          >
            40'
          </StyledButton>
          <StyledButton
            type="default"
            style={{
              width: '100px',
              fontSize: '13px',
              borderColor: `${type}` === "40'HC" ? '#0093ee' : '',
            }}
            onClick={() => this.onBtnsClick("40'HC")}
            color={`${type}` === "40'HC" ? '#0093ee' : '#627b93'}
          >
            40'HC
          </StyledButton>
          {!removeFcl45HcContainer && (
            <StyledButton
              type="default"
              style={{
                width: '100px',
                fontSize: '13px',
                borderColor: `${type}` === "45'HC" ? '#0093ee' : '',
              }}
              onClick={() => this.onBtnsClick("45'HC")}
              color={`${type}` === "45'HC" ? '#0093ee' : '#627b93'}
            >
              45'HC
            </StyledButton>
          )}
          <Checkbox
            onChange={this.onCheckboxChange}
            style={{ maxWidth: '125px', fontSize: '13px', color: '#627b93' }}
            checked={isOverweight}
          >
            Overweight
          </Checkbox>
        </StyledParentDiv>
      </>
    );
  }
}

RowMainContent.propTypes = {
  /**
   * fcl shipping data
   */
  fclShipping: PropTypes.object,
  /**
   * Whether to remove 45' HC from fcl container
   */
  removeFcl45HcContainer: PropTypes.object,
  /**
   * single added load `id`
   */
  rowId: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    // isFclTabActive: state.form.isFclTabActive,
    fclShipping: state.form.fclShipping,
    removeFcl45HcContainer: state.code_config.removeFcl45HcContainer,
  };
};

export default connect(mapStateToProps, actions)(RowMainContent);
